import React from 'react';

type Props = {
  width: string
}

export const UserSvg = (props: Props): React.ReactElement => {
  return <svg xmlns="http://www.w3.org/2000/svg" width={props.width} viewBox="0 0 115 79">
    <g id="Ikona_-_uživatel" data-name="Ikona - uživatel" transform="translate(-426.552 -350.756)">
      <path id="user-large-solid"
        d="M18.843,21.2a10.6,10.6,0,1,0-10.6-10.6A10.6,10.6,0,0,0,18.843,21.2Zm-6.97,2.355A11.871,11.871,0,0,0,0,35.426a2.26,2.26,0,0,0,2.26,2.26H35.426a2.26,2.26,0,0,0,2.26-2.26A11.871,11.871,0,0,0,25.813,23.553Z"
        transform="translate(473.552 363.756)" fill="#1e3050"/>
      <path id="Subtraction_10" data-name="Subtraction 10"
        d="M2979-1393h-79a10.011,10.011,0,0,1-10-10v-44a10.011,10.011,0,0,1,10-10v54h89A10.011,10.011,0,0,1,2979-1393Z"
        transform="translate(-2463.448 1822.756)" fill="#ef7f1a"/>
      <g id="Rectangle_89" data-name="Rectangle 89" transform="translate(442.552 350.756)" fill="none"
        stroke="#1e3050" strokeWidth="5">
        <rect width="99" height="64" rx="10" stroke="none"/>
        <rect x="2.5" y="2.5" width="94" height="59" rx="7.5" fill="none"/>
      </g>
    </g>
  </svg>

}
